import { render, staticRenderFns } from "./mateImage.vue?vue&type=template&id=3bbfdcb2"
import script from "./mateImage.vue?vue&type=script&lang=js"
export * from "./mateImage.vue?vue&type=script&lang=js"
import style0 from "./mateImage.vue?vue&type=style&index=0&id=3bbfdcb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports